import * as React from 'react';
import { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Plus as PlusIcon } from '@phosphor-icons/react/dist/ssr/Plus';
import type Organisation from 'benchmarking-domain/organisation';
import { OrganisationsTable } from 'components/admin/organisations/organisations-table';
import useApi from 'hooks/use-api';
import { useNavigate } from 'react-router-dom';

import { paths } from '../../../paths';

export default function Organisations(): React.JSX.Element {
  const navigate = useNavigate();

  const { subscribeOrganisations } = useApi();
  const [organisations, setOrganisations] = useState<Organisation[]>([]);

  useEffect(() => {
    const unsubscribe = subscribeOrganisations((fetchedOrganisations) => {
      setOrganisations(fetchedOrganisations?.sort((one, two) => (one.name < two.name ? -1 : 1)));
    });

    return () => {
      unsubscribe();
    };
  }, [subscribeOrganisations]);

  return (
    <Stack spacing={3}>
      <Stack direction="row" spacing={3}>
        <Stack spacing={1} sx={{ flex: '1 1 auto' }}>
          <Typography variant="h4">Organisations</Typography>
        </Stack>
        <div>
          <Button
            startIcon={<PlusIcon fontSize="var(--icon-fontSize-md)" />}
            onClick={() => {
              navigate(paths.app.admin.organisations.add);
            }}
            variant="contained"
          >
            Add
          </Button>
        </div>
      </Stack>

      <OrganisationsTable rows={organisations} />
    </Stack>
  );
}
